import React, { useEffect, useLayoutEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { useDispatch, useSelector } from "react-redux"
import { FaBan, FaEye } from "react-icons/fa";
import { useHistory } from "react-router-dom"
import dummy from '../../Assets/Images/dummy.jpg.webp'
import { setAlert } from "../../Store/Theme/actions"
import { BsBookmarkHeart, BsBookmarkHeartFill, BsHeartFill } from "react-icons/bs"
import Dialog from "../../Components/Dialog"
import Button from "../../Components/Button"
import { setCountApi } from "../../Store/Auth/actions"
import { useTranslation } from "react-i18next"
import ProfileListLoader from "../../Components/Loaders/ProfileListLoader"
import { MdOutlineClose } from "react-icons/md";
import { FaRegHeart } from "react-icons/fa6";
import Spinner from "../../Components/Loaders/Spinner";
import Footer from "./Footer";
const ProfileList = () => {

    const userDetails = useSelector((state) => state.auth.userDetails)
    const educationList = useSelector((state) => state.auth.educationList)
    const zodiacSigns = useSelector((state) => state.auth.zodiacSigns)
    const flaws = useSelector((state) => state.auth.flaws)
    const allStars = useSelector((state) => state.auth.allStars)
    const [loading, setLoading] = useState(true)
    const [profileList, setProfileList] = useState([])
    const occupationFilter = useSelector((state) => state.auth.occupationFilter)
    const flawFilter = useSelector((state) => state.auth.flawFilter)
    const statusFilter = useSelector((state) => state.auth.statusFilter)
    const zodiacSignFilter = useSelector((state)=>state.auth.zodiacSignFilter)
    const history = useHistory()
    const [planActive, setPlanActive] = useState(false)
    const dispatch = useDispatch()
    const [downloadConfirm, setDownloadConfirm] = useState(false)
    const [downloadDetail, setDownloadDetail] = useState()
    const [contactInfoVisible, setContactInfoVisible] = useState(false)
    const [selectedProfile, setSelectedProfile] = useState()
    const countApi = useSelector((state) => state.auth.countApi)
    const [confirmLoading, setConfirmLoading] = useState(false)
    const lang = useSelector((state) => state.theme.language)
    const { t } = useTranslation()
    const [page, setPage] = useState(() => {
        const savedPage = localStorage.getItem("profileListPage");
        return savedPage ? parseInt(savedPage) : 1;
    });
    const [limit, setLimit] = useState(20);
    const [totalPages, setTotalPages] = useState(1);
    const searchValue = useSelector((state) => state.auth.searchValue)
    const minAge = useSelector((state) => state.auth.minAge)
    const maxAge = useSelector((state) => state.auth.maxAge)
    const searchCount = useSelector((state) => state.auth.searchCount)

    useEffect(() => {
        if (userDetails?.profileType !== undefined) {
            if (searchCount > 0 && searchValue) {
                setProfileList([])
                setLoading(true)
                searchProfile()
            } else {
                fetchProfiles()
            }
            localStorage.setItem("profileListPage", page?.toString());
        }
    }, [userDetails, page]);

    useLayoutEffect(() => {
        if (userDetails?.profileType !== undefined) {
            setPage(page);
            fetchProfiles();
        }
    }, [flawFilter, occupationFilter, zodiacSignFilter, minAge, maxAge]);

    const fetchProfiles = () => {
        setProfileList([])
        setLoading(true);
        if(userDetails.profileType !== undefined){
            let apiEndpoint = `/user/getProfileList?profileType=${userDetails?.profileType}&year=${userDetails?.year}&page=${page}&limit=${limit}&minAge=${minAge}&maxAge=${maxAge}`;
    
            const queryParams = [];
            if (occupationFilter?.length > 0) {
                queryParams?.push(`occupationFilter=${occupationFilter?.map(c => c._id).join(',')}`);
            }
            if (flawFilter?.length > 0) {
                queryParams?.push(`flawFilter=${flawFilter?.map(c => c.value).join(',')}`);
            }
            if (zodiacSignFilter?.length > 0) {
                queryParams?.push(`zodiacSignFilter=${zodiacSignFilter?.map(c => c.value).join(',')}`);
            }
            if (queryParams?.length > 0) {
                apiEndpoint += `&${queryParams?.join('&')}`;
            }
    
            API.get(apiEndpoint).then((getRes) => {
                if (getRes?.status === 200) {
                    const res = getRes?.data;
                    setProfileList(res?.data?.data); // assuming `data` holds the profiles
                    setTotalPages(res?.data?.totalPages || 1); // add total pages support in backend response
                    setPlanActive(userDetails?.planActive);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    setLoading(false);
                }
            }).catch((err) => {
                console.log(err);
                setLoading(false);
            });
        }
    }

    useEffect(() => {
        if (searchCount && searchCount > 0 && searchValue) {
            setPage(1)
            setProfileList([])
            setLoading(true)
            searchProfile()
        } else {
            fetchProfiles()
        }
    }, [searchCount])

    // Scroll to top when page changes
    useEffect(() => {
        // Immediate scroll to top
        window.scrollTo({ top: 0, behavior: 'smooth' })
        
        // Also scroll the main container to top
        const timer = setTimeout(() => {
            const mainContainer = document.querySelector('.overflow-y-auto')
            if (mainContainer) {
                mainContainer.scrollTop = 0
            }
            
            // Scroll the profile list into view
            const profileList = document.querySelector('#ProfileList')
            if (profileList) {
                profileList.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
        }, 100)
        
        return () => clearTimeout(timer)
    }, [page])

    const searchProfile = () => {
        let apiEndpoint = `/user/searchProfile?profileType=${userDetails?.profileType}&searchValue=${searchValue}&page=${searchCount === 1 ? 1 : page}&limit=${limit}`;
        API.get(apiEndpoint).then((getRes) => {
            if (getRes?.status === 200) {
                const res = getRes?.data;
                setProfileList(res?.data?.data); 
                setTotalPages(res?.data?.totalPages || 1); 
                setPlanActive(userDetails?.planActive);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setLoading(false);
            }
        }).catch((err) => {
            console.log(err);
            setLoading(false);
        });
    }

    const calculateAge = (birthdate) => {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        // If birth month is after current month or same month but birth date is after current date, subtract 1
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    };

    const getFlaws = (value) => {
        return flaws.filter((x) => x.value === value)[0].text
    }

    const getQualification = (value) => {
        return educationList?.filter((x) => { return x?.value === value })[0]?.text
    }

    const profileShortlist = (value) => {
        let apiValues = {
            profileId: value?._id,
            addedBy: userDetails?._id
        }
        API.post('/user/bookmarkUser', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: 'Action successfull', type: 'success', active: true }))
                setProfileList(profileList.map((c) => {
                    if (c._id === wishRes?.data?.data?.profileId) {
                        c.isWishlisted = !c?.isWishlisted
                    }
                    return c
                }))
                dispatch(setCountApi(countApi + 1))
            }
        })
    }

    const notInterstProfile = (value) => {
        let apiValues = {
            profileId: value?._id,
            addedBy: userDetails?._id
        }
        API.post('/user/notInterest', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                dispatch(setAlert({ title: 'Success', subtitle: 'Action successfull', type: 'success', active: true }))
                setProfileList(profileList?.filter((x) => x._id !== wishRes?.data?.data?.profileId))
            }
            dispatch(setCountApi(countApi + 1))
        })
    }

    const downloadProfile = (value) => {
        setDownloadConfirm(true)
        setDownloadDetail(value)
    }

    const confirmDownload = () => {
        setConfirmLoading(true)
        try {
            let apiValues = {
                profileId: downloadDetail?._id,
                addedBy: userDetails?._id
            }
            API.post('/user/downloadProfile', apiValues).then((apiRes) => {
                if (apiRes?.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Profile Downloaded Successfully', type: 'success', active: true }))
                    setDownloadDetail()
                    setDownloadConfirm(false)
                    setConfirmLoading(false)
                    dispatch(setCountApi(countApi + 1))
                    setProfileList(profileList.map((c) => {
                        if (c._id === apiRes?.data?.data?.profileId) {
                            c.isDownloaded = true
                        }
                        return c
                    }))
                }
            }).catch((err) => {
                setConfirmLoading(false)
                dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', type: 'error', active: true }))
            })
        } catch (err) {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', type: 'error', active: true }))
        }
    }

    const [goToPage, setGoToPage] = useState(page);

    const clearHeights = (height) => {
        if(height){
            let input = height;
        let cleaned = input.match(/\d+\s*ft\s*\d*\s*in/);
        return cleaned ?  cleaned[0] : '--'
        }else{
            return '--'
        }
    }

    const scrollToTop = () => {
        const contentArea = document.querySelector('.overflow-y-auto')
        if (contentArea) {
            contentArea.scrollTop = 0
        } else {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    const showContactInfo = (profile) => {
        setSelectedProfile(profile)
        setContactInfoVisible(true)
    }

    return (
        <motion.div className="w-full h-[85vh] flex flex-col gap-2">
            {
                loading && profileList?.length === 0 ? <motion.div className="w-full min-h-screen justify-center items-center flex flex-col">
                    <Spinner />
                    </motion.div>: (
                    <motion.div className="flex flex-col gap-2 px-2 sm:px-4 md:px-6" id={'ProfileList'}>
                        {
                            profileList && profileList?.length > 0 ? profileList?.map((c, i) => (
                                <motion.div
                                    key={i}
                                    className="flex flex-col rounded-lg bg-white gap-5 p-4 shadow-sm"
                                // Add padding and shadow for better UI on all screens
                                >
                                    <motion.div className="flex flex-col gap-5">
                                        <motion.div
                                            className="flex flex-col sm:flex-row justify-start gap-5"
                                        // On small screens stack vertically, from sm breakpoint go horizontal
                                        >
                                            <motion.div className="flex flex-col gap-2 relative w-[150px] md:w-[244px]">
                                                {/* width 100% on mobile, fixed width on sm+ */}
                                                {(c?.previewUrls && c?.previewUrls[0]) ? (
                                                    <img
                                                        src={(planActive || c?.isDownloaded) ? c?.previewUrls[0] : dummy}
                                                        className="w-full h-[150px] md:h-[244px] object-center rounded-md"
                                                        alt="Preview"
                                                    />
                                                ) : (
                                                    <img
                                                        src={dummy}
                                                        className="w-full h-[150px] md:h-[244px] object-center rounded-md"
                                                        alt="Preview"
                                                    />
                                                )}
                                            <motion.div className="flex flex-row cursor-pointer items-center px-2 py-2 text-white w-full justify-center hidden md:inline-flex bg-primeColor rounded-full "
                                                    onClick={() => planActive ? history.push(`/fullProfile/${c._id}`) : history.push('/subscription')}>
                                                        <FaEye className="text-white" size={14} />&nbsp;&nbsp;  <p className="text-sm">{t('View Full Profile')}</p>
                                                    </motion.div>
                                            </motion.div>
                                            <motion.div className="flex flex-col w-full relative gap-1">
                                                {lang === 'en' && (
                                                    <p
                                                        className="text-xl hover:underline cursor-pointer font-bold text-primeColor"
                                                        onClick={() => planActive ? history.push(`/fullProfile/${c?._id}`) : history.push('/subscription')}
                                                    >
                                                        {c?.firstName} ({c?.surname})
                                                    </p>
                                                )}
                                                {lang === 'ta' && (
                                                    <p
                                                        className="text-xl hover:underline cursor-pointer font-bold text-primeColor"
                                                        onClick={() => planActive ? history.push(`/fullProfile/${c?._id}`) : history.push('/subscription')}
                                                    >
                                                        {c?.tFirstName} ({c?.tSurname})
                                                    </p>
                                                )}
                                                <p className="text-[gray] text-md font-bold">{c?.refId}</p>
                                                <motion.div className="flex flex-wrap items-center gap-2 text-sm sm:text-base">
                                                    {/* flex-wrap so items break nicely on small screens */}
                                                    <p>{calculateAge(c?.dateOfBirth)} {t('Yrs')}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <p>{clearHeights(c?.heightInFeet) || '-'}</p>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <span className="font-bold">{planActive || c?.isDownloaded ? zodiacSigns?.find(x => x?.value === c?.additionalInformation?.zodiacSign)?.text : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <span className="font-bold">{planActive || c?.isDownloaded ? allStars?.find(x => x?.value === c?.additionalInformation?.star)?.text || '---' : '----'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    <span className="font-bold">{c?.otherEducationalQualification || '--'}</span>
                                                    <motion.div className="h-2 w-2 rounded-full bg-[lightGray]" />
                                                    {(planActive || c.isDownloaded)
                                                        ? (c?.occupation !== 'undefined' && c?.occupation?.toString().trim().length ? c?.occupation : 'Not working')
                                                        : '----'}
                                                </motion.div>
                                                <motion.div className="flex flex-col md:flex-row flex-wrap sm:flex-nowrap gap-2 mt-4 sm:absolute sm:bottom-0 w-full">
                                                    <motion.div className="flex-1 flex flex-row cursor-pointer items-center px-2 py-2 text-white w-full justify-center block md:hidden bg-primeColor rounded-full "
                                                    onClick={() => planActive ? history.push(`/fullProfile/${c._id}`) : history.push('/subscription')}>
                                                        <FaEye className="text-white" size={14} />&nbsp;&nbsp;  <p className="text-sm">{t('View Full Profile')}</p>
                                                    </motion.div>
                                                    {/* On small screen wrap buttons, on sm+ position at bottom */}
                                                    <motion.div
                                                        className="flex-1 sm:w-40 flex flex-row border border-[lightGray] text-[grey] justify-center cursor-pointer items-center rounded-full px-2 py-2"
                                                        onClick={() => notInterstProfile(c)}
                                                    >
                                                        <MdOutlineClose className="text-grey" size={14} />&nbsp; <p className="text-sm">{t(`Don't show`)}</p>
                                                    </motion.div>
                                                    <motion.div
                                                        className="flex-1 sm:w-40 flex flex-row border border-primeColor bg-primeColor/30 text-black font-bold cursor-pointer justify-center items-center rounded-full px-2 py-2"
                                                        onClick={() => profileShortlist(c)}
                                                    >
                                                        {c.isWishlisted ? <BsBookmarkHeartFill size={14} /> : <BsBookmarkHeart size={14} />}&nbsp;&nbsp;  <p className="text-sm">{c.isWishlisted ? t('Shortlisted') : t('Shortlist')}</p>
                                                    </motion.div>
                                                    <motion.div
                                                        className="flex-1 sm:w-40 flex flex-row border border-primeColor bg-primeColor text-white cursor-pointer justify-center items-center rounded-full px-2 py-2"
                                                    onClick={()=> !c.isDownloaded ? downloadProfile(c) : showContactInfo(c)}>
                                                        {c.isDownloaded ? <BsHeartFill className="text-white" size={14}/> :  <FaRegHeart className="text-white" size={14} />}&nbsp;&nbsp;  <p className="text-sm">{!c.isDownloaded ? t('Send Interest') : t("View Contact Information")}</p>
                                                    </motion.div>
                                                </motion.div>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                </motion.div>
                            )) : <motion.div className="w-full min-h-screen flex flex-col items-center justify-center">
                                <p className="font-bold text-md">No Profiles to show</p>
                                </motion.div>
                        }
                       {profileList.length > 0 && <div className="flex flex-wrap items-center justify-center gap-2 mt-4 md:px-2">
                            {/* Pagination Buttons */}
                            <button
                                onClick={() => { setPage(1); scrollToTop(); }}
                                disabled={page === 1}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                {t('First')}
                            </button>
                            <button
                                onClick={() => { setPage(prev => Math.max(prev - 1, 1)); scrollToTop(); }}
                                disabled={page === 1}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                {t('Previous')}
                            </button>
                            {[
                                1,
                                ...(page > 3 ? ['...'] : []),
                                ...[page - 1, page, page + 1].filter(p => p > 1 && p < totalPages),
                                ...(page < totalPages - 2 ? ['...'] : []),
                                totalPages > 1 ? totalPages : null
                            ].map((p, index) =>
                                p === '...' ? (
                                    <span key={`ellipsis-${index}`} className="px-3 py-1">
                                        ...
                                    </span>
                                ) : (
                                    <button
                                        key={p}
                                        onClick={() => { setPage(p); scrollToTop(); }}
                                        className={`px-3 py-1 rounded ${page === p ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                                    >
                                        {p}
                                    </button>
                                )
                            )}
                            <button
                                onClick={() => { setPage(prev => Math.min(prev + 1, totalPages)); scrollToTop(); }}
                                disabled={page === totalPages}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                {t('Next')}
                            </button>
                            <button
                                onClick={() => { setPage(totalPages); scrollToTop(); }}
                                disabled={page === totalPages}
                                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                            >
                                {t('Last')}
                            </button>
                            <div className="flex items-center gap-2 ml-0 sm:ml-4 mt-2 sm:mt-0">
                                <input
                                    type="number"
                                    min={1}
                                    max={totalPages}
                                    value={page}
                                    onChange={(e) => setGoToPage(Number(e.target.value))}
                                    className="w-16 px-2 py-1 border rounded"
                                    placeholder={t('Page')}
                                />
                                <button
                                    onClick={() => {
                                        if (goToPage >= 1 && goToPage <= totalPages) {
                                            setPage(goToPage);
                                            scrollToTop();
                                        }
                                    }}
                                    className="px-3 py-1 bg-blue-500 text-white rounded"
                                >
                                    {t('Go')}
                                </button>
                            </div>
                        </div>}
                        <motion.div className="bottom-0 md:hidden block inset-x-0">
                    <Footer />
                </motion.div>
                    </motion.div>
                )
            }

            {/* Download Confirm Dialog */}
            <Dialog title={'Download Confirm'} showDialog={downloadConfirm} onClose={() => { setDownloadDetail(); setDownloadConfirm(false); }}>
                <motion.div className="h-full w-full flex flex-col gap-5 px-2 py-2">
                    <p>Are you sure you want to download this profile?</p>
                    <motion.div className="flex justify-center gap-2">
                        <Button type="primary" disabled={confirmLoading} injectClass="rounded-md" onClick={() => !confirmLoading && confirmDownload()}>
                            Yes
                        </Button>
                        <Button type="secondary" injectClass="rounded-md" onClick={() => { setDownloadDetail(); setDownloadConfirm(false); }}>
                            No
                        </Button>
                    </motion.div>
                </motion.div>
            </Dialog>

            {/* Contact Info Dialog */}
            <Dialog title={'Contact Information'} showDialog={contactInfoVisible} onClose={() => { setSelectedProfile(); setContactInfoVisible(false); }}>
                <motion.div className="h-full w-full flex flex-col gap-4 px-4 py-4">
                    {selectedProfile && (
                        <>
                            <div className="flex flex-col gap-2">
                                <p className="font-semibold text-primeColor">Phone Number:</p>
                                <p className="text-sm">{selectedProfile.contactInformation?.mobileNumber || 'Not available'}</p>
                            </div>
                            <div className="flex flex-col gap-2">
                                <p className="font-semibold text-primeColor">Email:</p>
                                <p className="text-sm">{selectedProfile.contactInformation?.email || 'Not available'}</p>
                            </div>
                            <div className="flex flex-col gap-2">
                                <p className="font-semibold text-primeColor">Present Address:</p>
                                <div className="text-sm space-y-1">
                                    <p>{selectedProfile.contactInformation?.presentAddress?.addressLine1 || '--'}</p>
                                    {selectedProfile.contactInformation?.presentAddress?.addressLine2 && (
                                        <p>{selectedProfile.contactInformation?.presentAddress?.addressLine2}</p>
                                    )}
                                    <p>{selectedProfile.contactInformation?.presentAddress?.city || '--'}</p>
                                    <p>{selectedProfile.contactInformation?.presentAddress?.district || '--'} - {selectedProfile.contactInformation?.presentAddress?.pinCode || '--'}</p>
                                    <p>{selectedProfile.contactInformation?.presentAddress?.state || '--'}</p>
                                </div>
                            </div>
                            <div className="flex flex-col gap-2">
                                <p className="font-semibold text-primeColor">Native Address:</p>
                                <div className="text-sm space-y-1">
                                    <p>{selectedProfile.contactInformation?.nativeAddress?.addressLine1 || '--'}</p>
                                    {selectedProfile.contactInformation?.nativeAddress?.addressLine2 && (
                                        <p>{selectedProfile.contactInformation?.nativeAddress?.addressLine2}</p>
                                    )}
                                    <p>{selectedProfile.contactInformation?.nativeAddress?.city || '--'}</p>
                                    <p>{selectedProfile.contactInformation?.nativeAddress?.district || '--'} - {selectedProfile.contactInformation?.nativeAddress?.pinCode || '--'}</p>
                                    <p>{selectedProfile.contactInformation?.nativeAddress?.state || '--'}</p>
                                </div>
                            </div>
                        </>
                    )}
                    <motion.div className="flex justify-center mt-4">
                        <Button type="primary" injectClass="rounded-md" onClick={() => { setSelectedProfile(); setContactInfoVisible(false); }}>
                            Close
                        </Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    )
}

export default ProfileList